import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/* items: [{label, to}] — last item is the current page */
export function Breadcrumbs({ items = [] }) {
  return (
    <nav aria-label="Breadcrumb" className="max-w-[1400px] mx-auto px-6 md:px-12 pt-28 md:pt-32">
      <ol className="flex flex-wrap items-center gap-2 mono-label text-zinc-600">
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={it.to} className="flex items-center gap-2">
              {last ? (
                <span className="text-zinc-400" aria-current="page">{it.label}</span>
              ) : (
                <Link to={it.to} className="hover:text-cyan-300 transition-colors">{it.label}</Link>
              )}
              {!last && <ChevronRight className="h-3 w-3 text-zinc-700" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
